module.exports = __webpack_public_path__ + "static/img/redis-list.a3fcb288.svg";